import ReportingTemplatesAdd from './container';

export default ReportingTemplatesAdd;
